import { defaultState as currencyClient } from './schemas/currencyClientSchema'

export const defaults = context => currencyClient(context)
